import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, X, Zap, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function TrialOfferPopup({ onClose, onAccepted }) {
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/checkout/trial`, {
        origin_url: window.location.origin
      });
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      const msg = err.response?.data?.detail;
      toast.error(typeof msg === 'string' ? msg : 'Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-testid="trial-offer-popup">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-fade-in">
        
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-text-light hover:text-dark transition-colors"
          data-testid="trial-offer-close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-primary-light rounded-full flex items-center justify-center mx-auto mb-4">
            <Zap className="w-8 h-8 text-primary" />
          </div>
          <h2 className="font-heading font-bold text-dark text-2xl mb-2">
            Unlimited Access
          </h2>
          <p className="text-text-secondary">
            Try everything for your first month
          </p>
        </div>

        <div className="bg-primary-light rounded-xl p-5 mb-6">
          <div className="flex items-baseline justify-center gap-1 mb-4">
            <span className="text-4xl font-extrabold text-primary">£3</span>
            <span className="text-text-secondary text-sm">/first month</span>
          </div>
          <ul className="space-y-3">
            {[
              'Unlimited direct debit entries',
              'Full dashboard & insights',
              'Calendar export to all platforms',
              'Cancel anytime from settings'
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-sm text-dark">
                <Check className="w-4 h-4 text-primary flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <Button
          onClick={handleAccept}
          disabled={loading}
          className="btn-primary w-full py-4 text-base font-bold mb-3"
          data-testid="trial-offer-accept"
        >
          {loading ? (
            <Loader2 className="w-5 h-5 animate-spin mx-auto" />
          ) : (
            'Get Unlimited for £3'
          )}
        </Button>

        <button
          onClick={onClose}
          className="w-full text-center text-sm text-text-light hover:text-text-secondary transition-colors py-2"
          data-testid="trial-offer-decline"
        >
          No thanks, I'll stick with 3 free entries
        </button>

        <p className="text-center text-xs text-text-light mt-3">
          After your trial month, your plan continues at £5/month. You can cancel or change plan anytime.
        </p>
      </div>
    </div>
  );
}
